module.exports = __webpack_public_path__ + "img/Statement_B.d7d6dd1d.svg";